export * from './useSendMails.graphql';
export * from './useSendMails';
export * from './useSendMails.interfaces';
